export type WaitingType = 'fashplay' | 'fashsnap' | 'fashmatch';
export type WaitingState = 'GENERATING' | 'READY' | 'FINALIZING' | 'COMPLETED';
export type WaitingSessionStatus = 'generating' | 'ready' | 'finalizing' | 'completed';

export interface WaitingConfigModules {
  reels: boolean;
  brand_reels: boolean;
  chat_offer: boolean;
  highlight: boolean;
}

export interface WaitingConfigTriggers {
  highlight_pct: number;
  chat_pct: number;
}

export interface WaitingConfig {
  layout: string;
  soft_gate_seconds: number;
  estimated_duration_seconds: number;
  modules: WaitingConfigModules;
  triggers: WaitingConfigTriggers;
}

export interface WaitingSession {
  id: string;
  brandId: string;
  userId: string | null;
  waitingType: WaitingType;
  configId: string | null;
  status: WaitingSessionStatus;
  startedAt: string;
  readyAt: string | null;
  completedAt: string | null;
  metadata: WaitingSessionMetadata;
}

export interface WaitingSessionMetadata {
  productSku?: string;
  gender?: string;
  bodyType?: string;
  [key: string]: unknown;
}

export interface ReelProduct {
  sku: string;
  name: string;
  imageUrl: string;
  price: number;
  currency: string;
  brand: string;
  url?: string;
}

export interface ReelItem {
  id: string;
  videoUrl: string;
  thumbnailUrl?: string;
  createdAt: string;
  source?: 'user' | 'brand';
  product: ReelProduct | null;
}

export type WaitingEventName =
  | 'waiting_started'
  | 'waiting_ready'
  | 'continue_clicked'
  | 'waiting_completed'
  | 'reels_swipe'
  | 'reels_view'
  | 'product_click'
  | 'chat_opened';

export interface WaitingEvent {
  sessionId: string;
  eventName: WaitingEventName;
  properties?: Record<string, unknown>;
}

export interface WaitingContext {
  state: WaitingState;
  sessionId: string | null;
  config: WaitingConfig | null;
  configId: string | null;
  progressPercent: number;
  elapsedSeconds: number;
  isResultReady: boolean;
  reels: ReelItem[];
  currentReelIndex: number;
}

export interface WaitingOrchestratorProps {
  brandId: string;
  waitingType: WaitingType;
  productSku?: string;
  userId?: string;
  onComplete: () => void;
  onResultReady?: () => void;
  checkResultReady: () => Promise<boolean>;
  onCreateNewAvatar?: () => void;
  userMetadata?: {
    age?: number;
    height?: number;
    weight?: number;
    bodyType?: string;
    gender?: string;
    avatarUrl?: string;
  };
}

export const DEFAULT_WAITING_CONFIG: WaitingConfig = {
  layout: 'single_stream',
  soft_gate_seconds: 12,
  estimated_duration_seconds: 45,
  modules: {
    reels: true,
    brand_reels: false,
    chat_offer: false,
    highlight: false
  },
  triggers: {
    highlight_pct: 50,
    chat_pct: 70
  }
};
